__turbopack_context__.v({
  "box": "prose-editor-module__8dmsVG__box",
  "content": "prose-editor-module__8dmsVG__content",
  "gapcursor-blink": "prose-editor-module__8dmsVG__gapcursor-blink",
  "group": "prose-editor-module__8dmsVG__group",
  "linkActs": "prose-editor-module__8dmsVG__linkActs",
  "linkError": "prose-editor-module__8dmsVG__linkError",
  "linkForm": "prose-editor-module__8dmsVG__linkForm",
  "linkPanel": "prose-editor-module__8dmsVG__linkPanel",
  "linkSheet": "prose-editor-module__8dmsVG__linkSheet",
  "linkWrap": "prose-editor-module__8dmsVG__linkWrap",
  "notice": "prose-editor-module__8dmsVG__notice",
  "refAvatar": "prose-editor-module__8dmsVG__refAvatar",
  "refList": "prose-editor-module__8dmsVG__refList",
  "refName": "prose-editor-module__8dmsVG__refName",
  "refOption": "prose-editor-module__8dmsVG__refOption",
  "refPanel": "prose-editor-module__8dmsVG__refPanel",
  "refSheet": "prose-editor-module__8dmsVG__refSheet",
  "refStatus": "prose-editor-module__8dmsVG__refStatus",
  "strip": "prose-editor-module__8dmsVG__strip",
  "text": "prose-editor-module__8dmsVG__text",
});
